import { Typography } from '@mui/material';
import { TenantCountryCodeEnum } from 'probonio-shared-ui/api';
import { useTenant } from 'probonio-shared-ui/module/me';
import { useAppSelector } from '../../redux/hooks';

// code to emoji https://www.npmjs.com/package/react-country-flag?activeTab=code

// offset between uppercase ascii and regional indicator symbols
const OFFSET = 127397;
const countryCodeToEmoji = (countryCode: TenantCountryCodeEnum) =>
  countryCode.toUpperCase().replace(/./g, (char: string) => String.fromCodePoint(char.charCodeAt(0) + OFFSET));

export const TenantHeaderInfo: React.FC = () => {
  const { tenant } = useTenant();
  const user = useAppSelector(state => state.me.user);

  if (!tenant?.name) {
    return null;
  }

  const showFlag = !user?.employments?.some(employments => employments.tenantId === tenant.id);
  const countryFlag = showFlag ? countryCodeToEmoji(tenant.countryCode) : '';

  return (
    <Typography
      sx={{ verticalAlign: 'middle', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis' }}
      variant="h3"
      component="span"
      color="textSecondary"
      data-test-id="header-tenant-info"
    >
      {tenant.name}
      {tenant.bikeleasingCompanyCode && ` - ${tenant.bikeleasingCompanyCode}`} {countryFlag}
    </Typography>
  );
};
